import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MainLayout } from "./pages/MainLayout";
import CodeNotFound from "./pages/CodeNotFound";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";
import PageNotFound from "./pages/PageNotFound";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import { AppContext } from "./libs/contextLib";
import useSecretConfig from "./hooks/useSecretConfig";

// A custom hook to handle script loading
const useScript = (gaId) => {
  useEffect(() => {
    if (!gaId) return;
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", gaId);
    return () => {
      document.head.removeChild(script);
    };
  }, [gaId]);
};

// A custom hook for GTM script injection
const useGTM = (gtmId) => {
  useEffect(() => {
    if (!gtmId) return;

    // GTM script
    const script = document.createElement("script");
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;
    document.head.appendChild(script);

    // GTM noscript
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);

    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, [gtmId]);
};

function App() {
  const { data, loading, error } = useSecretConfig();
  const gaId = data?.gaId;
  const gTagMId = data?.gTagMId;

  useScript(gaId);

  useGTM(gTagMId);

  return (
    <AppContext.Provider value={{ configureData: data, loading, error }}>
      {loading && (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}

      {!loading && error && (
        <div className="text-center mt-5 text-danger">
          <p> Failed to load: {error}</p>
        </div>
      )}

      {!loading && !error && (
        <Routes>
          <Route path="/" element={<MainLayout />} />
          <Route path="/:offerCode" element={<MainLayout />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/code-note-found" element={<CodeNotFound />} />
          <Route path="*" exact={true} element={<PageNotFound />} />
        </Routes>
      )}
      <ToastContainer position="top-right" autoClose={5000} />
    </AppContext.Provider>
  );
}

export default App;
